import { motion, useInView, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect, useRef } from "react";

function Counter({ to, suffix = "" }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-80px" });
    const value = useMotionValue(0);
    const rounded = useTransform(value, (v) => Math.floor(v).toLocaleString());

    useEffect(() => {
        if (inView) {
            const controls = animate(value, to, { duration: 1.8, ease: [0.16, 1, 0.3, 1] });
            return controls.stop;
        }
    }, [inView, to, value]);

    return (
        <span ref={ref} className="serif-display text-6xl md:text-8xl text-[var(--gold)] tabular-nums">
            <motion.span>{rounded}</motion.span>{suffix}
        </span>
    );
}

const metrics = [
    { value: 25, suffix: "+", label: "Countries engaged" },
    { value: 1200, suffix: "+", label: "Youth leaders trained" },
    { value: 40, suffix: "+", label: "Institutional partners" },
    { value: 6, suffix: "", label: "Schools in the ecosystem" },
];

export default function ImpactMetrics() {
    return (
        <section data-testid="metrics-section" className="py-24 md:py-32 bg-[var(--navy)]">
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-24">
                <div className="mb-16 md:mb-20 flex items-end justify-between flex-wrap gap-6">
                    <div className="label-mono">— OUR REACH · SO FAR</div>
                    <div className="serif-italic text-2xl md:text-3xl text-[var(--ivory)]/80">…and only just beginning.</div>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-y md:divide-y-0 divide-[rgba(255,255,240,0.12)] border-t border-b md:border-t md:border-b border-[rgba(255,255,240,0.12)]">
                    {metrics.map((m, i) => (
                        <motion.div
                            key={m.label}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.7, delay: i * 0.1 }}
                            className="p-8 md:p-10"
                            data-testid={`metric-${i}`}
                        >
                            <Counter to={m.value} suffix={m.suffix} />
                            <div className="label-mono mt-4 text-[var(--ivory)]/70">{m.label}</div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
